import dayjs, { Dayjs } from 'dayjs'

import { Form, onFieldValueChange } from '@eastcoal/formily/exports/core'

const clearError = (_: any, form: Form) => {
  const { startTime, endTime } = form.values
  const minDate = dayjs(startTime || new Date())

  if (minDate.isBefore(dayjs(endTime), 'm')) form.clearErrors('endTime')
}

const setDisabledDate = (_: any, form: Form) => {
  const { startTime } = form.values
  const minDate = dayjs(startTime || new Date())

  form.setFieldState('endTime', state => {
    state.componentProps = {
      ...state.componentProps,
      disabledDate: (currentDate: Dayjs) => currentDate.isBefore(minDate, 'd')
    }
  })
}

export const endTimeEffect = () => {
  onFieldValueChange('startTime', setDisabledDate)
  onFieldValueChange('startTime', clearError)
}
